import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ExternalLink } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const [footerLinks, setFooterLinks] = useState([
    { key: "about", label: "About", url: "/about" },
    { key: "faq", label: "FAQ", url: "/faq" },
    { key: "updates", label: "Updates", url: "/updates" },
  ]);

  // Platform Links
  const platformLinks = [
    { name: "OnlyFans VIP", url: "https://onlyfans.com/giopilos" },
    { name: "JustForFans", url: "https://justfor.fans/giopilos" },
    { name: "Faphouse", url: "https://faphouse.com/studios/giopilos" },
    { name: "RawFuckClub", url: "https://rawfuckclub.com/giopilos" },
  ];

  // Social Links
  const socialLinks = [
    { name: "Twitter / X", url: "https://twitter.com/giopilos" },
    { name: "Instagram", url: "https://instagram.com/giopilos" },
    { name: "Telegram", url: "https://t.me/giopilos" },
    { name: "BlueSky", url: "https://bsky.app/profile/giopilos" },
  ];

  // Company Links
  const companyLinks = [
    { name: "About", path: "/about" },
    { name: "FAQ", path: "/faq" },
    { name: "Updates", path: "/updates" },
  ];

  // Legal Links
  const legalLinks = [
    { name: "Legal Hub", path: "/legal" },
    { name: "Terms", path: "/terms" },
    { name: "Privacy", path: "/privacy" },
    { name: "Takedown / DMCA", path: "/takedown" },
    { name: "Deletion", path: "/user-deletion" },
  ];

  useEffect(() => {
    // Fetch footer links from landing config
    fetch(`${process.env.REACT_APP_BACKEND_URL || ""}/api/public/landing`)
      .then(res => res.json())
      .then(data => {
        if (data.footer_links && data.footer_links.length > 0) {
          setFooterLinks(data.footer_links);
        }
      })
      .catch(() => {
        // Fallback to default links if fetch fails
      });
  }, []);

  return (
    <footer 
      className="border-t border-white/5 py-16 px-6 mt-auto"
      style={{ background: 'linear-gradient(to bottom, #000000, #0A0A0E)' }}
    >
      <div className="max-w-7xl mx-auto">
        
        {/* Main Footer Content - 5 Column Grid */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-12 mb-12">
          
          {/* Column 1: Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="relative">
                <img src="/gp-app-icon.png" alt="GP" className="w-12 h-12 rounded-xl border border-purple-500/30 shadow-lg shadow-purple-500/20" />
                <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-pink-500/20 to-purple-500/20 pointer-events-none" />
              </div>
              <h3 className="text-xl font-bold text-purple-400">
                GioPilos
              </h3>
            </div>
            <p className="text-sm text-zinc-500 leading-relaxed">
              Premium exclusive content. Browse free, upgrade on your favorite platform.
            </p>
          </div>

          {/* Column 2: Platforms */}
          <div>
            <h4 className="font-semibold mb-4 uppercase tracking-wider text-xs text-zinc-600">
              Watch On
            </h4>
            <ul className="space-y-3">
              {platformLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-purple-400 transition-colors"
                  >
                    {link.name}
                    <ExternalLink size={12} />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Social */}
          <div>
            <h4 className="font-semibold mb-4 uppercase tracking-wider text-xs text-zinc-600">
              Follow
            </h4>
            <ul className="space-y-3">
              {socialLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-zinc-400 hover:text-purple-400 transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Company */}
          <div>
            <h4 className="font-semibold mb-4 uppercase tracking-wider text-xs text-zinc-600">
              Company
            </h4>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-zinc-400 hover:text-purple-400 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 5: Legal */}
          <div>
            <h4 className="font-semibold mb-4 uppercase tracking-wider text-xs text-zinc-600">
              Legal
            </h4>
            <ul className="space-y-3">
              {legalLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-zinc-400 hover:text-purple-400 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
              <li className="pt-3 border-t border-white/5">
                <a
                  href="mailto:privacy@giopilos.com"
                  className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-purple-400 transition-colors"
                >
                  <Mail size={14} />
                  Privacy Inquiries
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent my-8" />

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Copyright */}
          <p className="text-sm text-zinc-600">
            © {currentYear} GioPilos. All rights reserved.
          </p>

          {/* Quick Links & Badge */}
          <div className="flex items-center gap-6">
            <Link 
              to="/" 
              className="text-sm text-zinc-500 hover:text-purple-400 transition-colors"
            >
              Home
            </Link>
            <Link 
              to="/legal" 
              className="text-sm text-zinc-500 hover:text-purple-400 transition-colors"
            >
              Legal
            </Link>
            <Link 
              to="/members/login" 
              className="text-sm text-zinc-500 hover:text-purple-400 transition-colors"
            >
              Member Login
            </Link>
            
            {/* 18+ Badge */}
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-red-500/10 border border-red-500/30">
              <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse" />
              <span className="text-xs font-bold text-red-400">18+ Platform</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
